import Debouncer from 'middlewares/Debouncer';
import { getTasks } from 'LoanOriginationSystemTasks/ActionCreator';
import { LoanOriginationSystemTasksFiltersActionTypes } from './ActionTypes';
import { UserInfo } from 'api/LoanOriginationSystem/LoanOriginationSystemApplicationsApi';

export default Debouncer<UserInfo[]>(() => {
  return getTasks();
}, [LoanOriginationSystemTasksFiltersActionTypes.FilterTasksByMembers]);
